import { useEffect, useRef } from 'react';

type ClickOutsideOptions = {
  capture?: boolean;
  enabled?: boolean;
};

export function useClickOutside<T extends HTMLElement>(
  callback?: null | ((e: PointerEvent) => void),
  options: ClickOutsideOptions = {
    capture: true,
    enabled: true,
  },
) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!callback || !options.enabled) return undefined;

    const doc = getDoc();
    const ac = new AbortController();

    doc.addEventListener(
      'pointerdown',
      (e: PointerEvent) => {
        if (ref.current && !ref.current?.contains(e.target as Node)) {
          callback?.(e);
        }
      },
      {
        capture: options.capture,
        signal: ac.signal,
      },
    );

    return () => ac.abort();
  }, [callback, options]);

  return ref;
}

export function useClickOutsideAlt<T extends HTMLElement>(
  callback?: null | ((e: MouseEvent) => void),
  options: ClickOutsideOptions = {
    capture: true,
    enabled: true,
  },
) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!callback || !options.enabled) return undefined;

    const doc = getDoc();
    const ac = new AbortController();

    // sic!
    doc.addEventListener(
      'click',
      (e: MouseEvent) => {
        if (ref.current && !ref.current?.contains(e.target as Node)) {
          callback?.(e);
        }
      },
      {
        capture: options.capture,
        signal: ac.signal,
      },
    );

    return () => ac.abort();
  }, [callback, options]);

  return ref;
}

// HACK: чтобы классы работали в iframe ladle (наш сторибук)
function getDoc() {
  if (process.env.NODE_ENV !== 'production') {
    const framedDoc = document.querySelector<HTMLIFrameElement>('.ladle-iframe')?.contentDocument;
    if (framedDoc) return framedDoc;
  }

  return document;
}
